import { LoadableAfterPaint } from '@confluence/loadable';

export const LazySpaceSettingsForgeExtensionPortal = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceSettingsForgeExtensionPortal" */ './SpaceSettingsForgeExtensionPortal.tsx'
			)
		).SpaceSettingsForgeExtensionPortal,
});
LazySpaceSettingsForgeExtensionPortal.displayName = 'LazySpaceSettingsForgeExtensionPortal';
